var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEnum, IsOptional, IsString } from "class-validator";
export var ContactMethod;
(function (ContactMethod) {
    ContactMethod["EMAIL"] = "EMAIL";
    ContactMethod["TEXT"] = "TEXT";
    ContactMethod["CALL"] = "CALL";
    ContactMethod["DO_NOT_CONTACT"] = "DO_NOT_CONTACT";
})(ContactMethod || (ContactMethod = {}));
export var UnderstandingHealthData;
(function (UnderstandingHealthData) {
    UnderstandingHealthData["ALL"] = "ALL";
    UnderstandingHealthData["OVERVIEW_ONLY"] = "OVERVIEW_ONLY";
})(UnderstandingHealthData || (UnderstandingHealthData = {}));
export class ConsentConfigInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], ConsentConfigInput.prototype, "excludeCurrentDataExplanationFromOnboarding", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], ConsentConfigInput.prototype, "showDeidentifiedDataExplanantion", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], ConsentConfigInput.prototype, "showExternalExplanation", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], ConsentConfigInput.prototype, "showInternalExplanation", void 0);
__decorate([
    IsOptional(),
    IsEnum(UnderstandingHealthData),
    __metadata("design:type", String)
], ConsentConfigInput.prototype, "understandingHealthData", void 0);
__decorate([
    IsOptional(),
    IsEnum(ContactMethod),
    __metadata("design:type", Object)
], ConsentConfigInput.prototype, "healthExPreferredContactMethod", void 0);
export class ConsentConfig extends ConsentConfigInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], ConsentConfig.prototype, "healthSystemId", void 0);
export class ConsentConfigTemplate extends ConsentConfigInput {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], ConsentConfigTemplate.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ConsentConfigTemplate.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ConsentConfigTemplate.prototype, "isDefault", void 0);
